<template>
  <svg class="xds:icon" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M5.62 5.62001C5.1538 5.97537 4.58612 6.17224 4 6.18182C2.09091 6.18182 1 4.00001 1 4.00001C1.33924 3.36779 1.80976 2.81544 2.38 2.38M3.42728 1.88364C3.615 1.8397 3.8072 1.81773 4 1.81818C5.90909 1.81818 7 4 7 4C6.83445 4.30971 6.63702 4.60129 6.41091 4.87M4.57817 4.57818C4.3742 4.79707 4.06702 4.88718 3.77713 4.81314C3.48724 4.73911 3.26088 4.51275 3.18684 4.22286C3.11281 3.93297 3.20291 3.62578 3.42181 3.42181M1 1L7 7"
      stroke="currentColor"
      stroke-width="0.4"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>
